// User-facing animal type labels — plain ranch-world names only.
// No scientific terms (no "equine"/"bovine"/"ovine") in the UI.

export const ANIMAL_TYPES = [
  { value: 'HORSE', label: 'Horse' },
  { value: 'COW', label: 'Cow' },
  { value: 'SHEEP', label: 'Sheep' },
  { value: 'GOAT', label: 'Goat' },
  { value: 'PIG', label: 'Pig' },
  { value: 'CHICKEN', label: 'Chicken' },
  { value: 'DOG', label: 'Dog' },
  { value: 'CAMEL', label: 'Camel' },
  { value: 'EXOTIC', label: 'Exotic' },
  { value: 'OTHER', label: 'Other' },
];

export const ANIMAL_LABELS = ANIMAL_TYPES.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});

export const ANIMAL_PLURALS = {
  HORSE: 'horses',
  COW: 'cows',
  SHEEP: 'sheep',
  GOAT: 'goats',
  PIG: 'pigs',
  CHICKEN: 'chickens',
  DOG: 'dogs',
  CAMEL: 'camels',
  EXOTIC: 'animals',
  OTHER: 'animals',
};

export const ANIMAL_SEX = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'GELDING', label: 'Gelding' },
  { value: 'UNKNOWN', label: 'Unknown' },
];

export const SEX_LABELS = ANIMAL_SEX.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export function formatAnimal(animal) {
  if (!animal) return '';
  const t = ANIMAL_LABELS[animal.animalType] || animal.animalType;
  return [animal.name, t, animal.breed, animal.age != null ? `${animal.age}y` : null]
    .filter(Boolean)
    .join(' • ');
}
